







import { Component } from 'vue-property-decorator'
import Cup from '../../assets/svg/cup.svg';
import PointList from './components/PointList.vue';
import AnalyticsMixin from "../../mixins/AnalyticsMixin";
import PointsIcon from '../../assets/svg/points-icon.svg';

@Component({
    name: 'Points',
    components: { Cup, PointList, PointsIcon }
})
export default class Points extends AnalyticsMixin {
    timerId?: number = undefined;

    get points(): number {
        return this.$store.getters['points/points']?.points || 0;
    }
}
